// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"679":"bb3b8a22","1717":"bb3b8a22","2322":"7eb48f0b","2561":"7eb48f0b"}[chunkId] + ".chunk.css";
};